var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenDet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#000",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.03 24.08-3.6.01-2.16-14.22v-.01a.93.93 0 0 0-.88-.8.93.93 0 0 0-.94.72l-3.85 16.8-2.35-9.89v-.02a.93.93 0 0 0-.89-.71.93.93 0 0 0-.9.68v.01l-1.84 7.26H9.95a.86.86 0 0 0 0 1.73h3.35c.39-.03.71-.3.83-.68v-.02l1.2-4.7 2.38 10.04v.02c.15.55.58.74.9.74h.02c.32 0 .75-.2.89-.76l3.67-16.04L24.82 25v.01c.07.44.42.77.84.8l.04.01 4.33-.02c.48 0 .86-.38.86-.86a.85.85 0 0 0-.86-.86Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h22v22H9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDet);
export default __webpack_public_path__ + "static/media/openDet.e8ebdad7ed2328110a52cbf61bb2f9ec.svg";
export { ForwardRef as ReactComponent };